<template>
  <div class="card dynamic search v-start">
    <div class="header h-stretch">
      <input
        ref="searchBar"
        placeholder="start typing to search"
        v-model="query"
        @input="inputChanged()"
        type="text"
      />
    </div>
    <div v-if="hasResult" class="content h-stretch scroll-y v-start">
      <div class="v-stack v-start gap-3 h-stretch">
        <a v-if="resultClients.length > 0" class="text-left">Clients</a>
        <div
          v-for="client in resultClients"
          :key="client._id"
          class="text-left link"
          @click="navigateTo('/clients/detail/' + client._id)"
        >
          {{ client.name }}
        </div>
        <a v-if="resultProjects.length > 0" class="text-left">Projects</a>
        <div
          v-for="project in resultProjects"
          :key="project._id"
          class="text-left link"
          @click="navigateTo('/projects/detail/' + project._id)"
        >
          {{ project.client.name }} - {{ project.title }}
          {{ project.subtitle }}
        </div>
        <a v-if="resultUsers.length > 0" class="text-left">Users</a>
        <div
          v-for="user in resultUsers"
          :key="user._id"
          class="text-left link"
          @click="navigateTo('/users/detail/' + user._id)"
        >
          {{ user.firstName }} {{ user.lastName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import EventBus from "@/eventbus.js";

export default {
  data() {
    return {
      resultProjects: [],
      resultClients: [],
      resultUsers: [],
      query: "",
      searchDebounceTimer: null,
      lastSearchRequestId: 0,
    };
  },
  computed: {
    hasResult() {
      if (this.resultProjects.length > 0) {
        return true;
      }
      if (this.resultClients.length > 0) {
        return true;
      }
      if (this.resultUsers.length > 0) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions(["getSearchResult"]),
    refresh() {
      this.$nextTick(() => {
        this.$refs.searchBar.focus();
      });

      this.query = "";

      this.resultProjects = [];
      this.resultClients = [];
      this.resultUsers = [];
    },
    inputChanged() {
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }

      if (this.query.length > 0) {
        // Debounce: wait 300ms after user stops typing
        this.searchDebounceTimer = setTimeout(() => {
          const requestId = ++this.lastSearchRequestId;
          // console.log("Searching...", requestId);

          this.getSearchResult(this.query)
            .then((result) => {
              // Only update if this is still the latest request
              if (requestId === this.lastSearchRequestId) {
                this.resultProjects = result.projects;
                this.resultClients = result.clients;
                this.resultUsers = result.users;
              } else {
                // console.log("Ignoring outdated response", requestId);
              }
            })
            .catch((error) => {
              if (requestId === this.lastSearchRequestId) {
                console.log(error);
              }
            });
        }, 300); // Wait 300ms after user stops typing
      } else {
        this.resultProjects = [];
        this.resultClients = [];
        this.resultUsers = [];
      }
    },
    navigateTo(path) {
      this.$router.push(path);
      this.$emit("dismiss");
    },
  },
  mounted() {
    EventBus.$on("refreshSearch", () => {
      this.refresh();
    });

    this.refresh();
  },
};
</script>

<style scoped>
.search {
  top: 30px;
  position: absolute;
  height: fit-content;
  max-height: calc(100vh - 90px);
  width: 80vw;
}

.header {
  border: none;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
